import { gql } from '@apollo/client';

export const REVIEW_REPORTING_SUBMISSION = gql`
  mutation reviewReportingSubmission($input: ReviewReportingSubmissionInput!) {
    review: reviewReportingSubmission(input: $input) {
      id
      status
    }
  }
`;
